'use strict'

const DAGLink = require('./index.js')

function create (name, size, multihash, callback) {
  const link = new DAGLink(name, size, multihash)
  callback(null, link)
}

module.exports = create



//////////////////
// WEBPACK FOOTER
// ./~/ipld-dag-pb/src/dag-link/create.js
// module id = 537
// module chunks = 0